$(function() {

    function formatMoney(price, currency) {
        currency = currency || TradeOrders.currency;

        price = +price;
        price = price.toFixed(2);
        price = currency+price;

        return price;
    }

    function getUrlVar(variable) {
        var result = false;

        window.location.search.substring(1).split('&').forEach(function(param) {
            if(param.split("=")[0]===variable) result=decodeURI(param.split("=")[1]);
        });

        return result;
    }

    $.ajax(TradeOrders.url+'/get-last-order', {
        dataType: "jsonp",
        data: {
            customer: TradeOrders.customer,
            address: TradeOrders.shopAddress,
            o: getUrlVar('o')
        },
        success: function(data) {
            if(data.error) {
                alert(data.message);
            } else {
                var order = data.order,
                    html = '',
                    price;

                for(var i=0,len=order.line_items.length; i<len; i++) {
                    //price = formatMoney(order.line_items[i].price*+order.line_items[i].quantity);

                    html += ''+
                    '<tr>'+
                    '<td><img class="images" src="'+order.line_items[i].image+'"></td>'+
                    '<td class="line-item-title">'+
                        order.line_items[i].title+' &nbsp;x'+order.line_items[i].quantity+'<br />';
                        if(order.line_items[i].variant_title!=='Default Title') {
                          if(order.line_items[i].variant_title) {
                          	html += '<small>'+order.line_items[i].variant_title+'</small>';
                          }
                            
                        }
                    html += '</td>'+
                    '<td> </td>'+
                    '</tr>'
                    ;
                }

                //if(parseFloat(order.total_discounts) > 0) {
                //    $('[data-value="discount"]').html(formatMoney(order.total_discounts));
                //} else {
                //    $('.discount-line').hide();
                //}

                //if(parseFloat(order.total_tax) > 0) {
                //    $('[data-value="tax"]').html(formatMoney(order.total_tax));
                //} else {
                //    $('[data-value="tax"]').html(formatMoney(0));
                //}

                if(order.shipping_lines[0]) {
                    if(!order.shipping_lines[0].price) order.shipping_lines[0].price = 0;
                    $('#trade-orders-shipping-name').text(order.shipping_lines[0].title);
                    $('#trade-orders-shipping-price').html(formatMoney(order.shipping_lines[0].price));
                    $('#trade-orders-shipping').show();
                }

                if($('[data-value="item_count"]').length) {
                    var item_count = order.line_items.reduce(function(count, line_item) {
                        return count+line_item.quantity;
                    },0);

                    $('[data-value="item_count"]').html(item_count);
                }

                $('[data-value="subtotal"]').html(formatMoney(order.total_line_items_price));
                $('[data-value="total"]').html(formatMoney(order.total_price));
                $('[data-value="name"]').html(order.name);

                $('#overview tbody').append(html);
            }
        },
        error: function(a,b,c) {
            console.log(a);
            console.log(b);
            console.log(c);
            alert('Failed to retrieve order details.');
        }
    });
});